const PURCHASE = "PURC";
const REFINANCE = "REFI";
const CONSTRUCTION = "CONS";

const LOAN_TYPE_CODES = {
  PURCHASE,
  REFINANCE,
  CONSTRUCTION,
};

export { LOAN_TYPE_CODES };

